import * as types from './constants';

export const setIsLoading = isLoading => ({
  type: types.SET_IS_LOADING,
  isLoading
});

export const setVehicleDamageList = result => ({
  type: types.SET_VEHICLE_DAMAGE_LIST,
  result
});